import gql from 'graphql-tag';

import type { SavedDocument } from 'src/data/savedDocument';
import { executeGqlQuery } from 'src/graphql/client';
import {
  getSingleProp,
  isGraphQLProjectNoAccessResult,
  throwIfResultHasErrors,
} from 'src/lib/graphql';
import type { BackendQueryProjectArgs } from 'src/types/backend';

import { FRAGMENT_SAVED_DOCUMENT } from './schema';

const QUERY = gql`
  query SavedDocument($id: Int!) {
    project(id: $id) {
      id
      savedDocument {
        ...SavedDocumentFields
      }
    }
  }
  ${FRAGMENT_SAVED_DOCUMENT}
`;

type Variables = BackendQueryProjectArgs;

// Resolves with null when the caller can't open the project.
export const querySavedDocument = async (variables: Variables): Promise<SavedDocument | null> => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  const project = getSingleProp<{ savedDocument: SavedDocument } | null>(result.data);
  // A project the caller can't open comes back as null, with the reason in `errors`.
  if (project === null && isGraphQLProjectNoAccessResult(result)) {
    return null;
  }
  throwIfResultHasErrors(result);
  return project?.savedDocument ?? null;
};
